import React from "react";

import { isArray } from "@dvrt/react-tools";
import { defineMessage, FormattedMessage } from "react-intl";
import DisabledDeleteResourceButton from "./DisabledDeleteResourceButton";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

const translations = {
    client: defineMessage({
        id: "role.client",
        defaultMessage: "$client.client",
    }),
    role: defineMessage({
        id: "user_roles.role",
        defaultMessage: "Role",
    }),
    contexts: defineMessage({
        id: "role.contexts",
        defaultMessage: "Contexts",
    }),
} as const;

function getUserContextCol(contexts, role) {
    const contextsToShow = [];

    for (const userContext of contexts) {
        for (const roleContext of role["role_contexts"]) {
            if (userContext.context.id == roleContext.context.id && roleContext["predefined_value"] == null) {
                contextsToShow.push(userContext);
                break;
            }
        }
    }

    if (contextsToShow.length == 1) {
        const context = contextsToShow[0];
        const rows = [];
        for (const key in context["context_data"]) {
            const val = context["context_data"][key];
            rows.push(
                <div>
                    {/* eslint-disable-next-line formatjs/enforce-default-message, formatjs/enforce-id */}
                    <FormattedMessage id={key} />: <span>{isArray(val) ? val.join(", ") : val}</span>
                </div>,
            );
        }
        return <div>{...rows}</div>;
    }
    // TODO: more than 1...

    return null;
}

type UserRoleSummaryProps = {
    userGrants: any[];
    userSubId: number;
    onUpdateRole?: (changed: boolean) => void;
};

const UserRoleSummary: React.FC<UserRoleSummaryProps> = ({ userGrants, userSubId }) => {
    userGrants.sort((a, b) => {
        if (a.id > b.id) return -1;
        if (a.id < b.id) return 1;
        return 0;
    });
    const rows = [];
    userGrants.forEach((grant, index) => {
        rows.push(
            <TableRow
                key={index}
                data-row-id={grant.id}
                data-client-id={grant.role.client.id}
                data-role-id={grant.role.id}
            >
                <TableCell>{grant.role.client["display_name"]}</TableCell>
                <TableCell>{grant.role.name}</TableCell>
                <TableCell>{getUserContextCol(grant["user_contexts"], grant.role)}</TableCell>
                <TableCell>
                    <DisabledDeleteResourceButton
                        resourceName="user_grant"
                        id={grant.id}
                        userId={userSubId}
                        tooltip={defineMessage({
                            id: "deleting_own_user_role_is_forbidden",
                            defaultMessage: "Deleting own user role is forbidden!",
                        })}
                    />
                </TableCell>
            </TableRow>,
        );
    });

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <FormattedMessage {...translations.client} />
                    </TableCell>
                    <TableCell>
                        <FormattedMessage {...translations.role} />
                    </TableCell>
                    <TableCell>
                        <FormattedMessage {...translations.contexts} />
                    </TableCell>
                    <TableCell />
                </TableRow>
            </TableHead>
            <TableBody>{...rows}</TableBody>
        </Table>
    );
};

export default UserRoleSummary;
